(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-list"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('.main-collection-grid-fix');
    if (!root) return;

    const hideFloatingAdd = () => {
      const selectors = [
        '.quick-add',
        '.quick-add__submit',
        '.card__quick-add',
        '.product-card__quick-add',
        '.card__floating-action',
        '.product-card__floating-action',
        '.card__badge--quick-add',
        'button[name="add"]',
        '[class*="quick-add"]',
        '[class*="quick_add"]',
        '[class*="floating"]',
        '[class*="add-button"]',
        '[class*="add_to_cart"]'
      ];

      root.querySelectorAll(selectors.join(',')).forEach((el) => {
        el.style.display = 'none';
        el.style.visibility = 'hidden';
        el.style.opacity = '0';
        el.style.pointerEvents = 'none';
      });
    };

    const fixReadableText = () => {
      root.querySelectorAll('.product-grid__item').forEach((item) => {
        const panels = item.querySelectorAll(
          '.card__content, .product-card__info, .card-information, .card__information, .card-information__wrapper, .product-card__content, .product-card__details, .product-card__meta'
        );

        panels.forEach((panel) => {
          panel.style.background = 'rgba(255,255,255,0.96)';
          panel.style.backgroundColor = 'rgba(255,255,255,0.96)';
          panel.style.backgroundImage = 'none';
          panel.style.boxShadow = 'none';
          panel.style.border = '1px solid rgba(0,0,0,0.06)';
          panel.style.borderRadius = '16px';
          panel.style.padding = '14px 14px 12px';
          panel.style.marginTop = '12px';
          panel.style.opacity = '1';
          panel.style.filter = 'none';
          panel.style.textShadow = 'none';
        });

        item.querySelectorAll(
          '.card__heading, .card__heading a, .card-information__text, .card-information__text a, .full-unstyled-link, .full-unstyled-link *, .product-card__title, .product-card__title a, .product-card__name, .product-card__name a'
        ).forEach((text) => {
          text.style.color = '#111111';
          text.style.opacity = '1';
          text.style.background = 'transparent';
          text.style.textShadow = 'none';
          text.style.filter = 'none';
        });

        item.querySelectorAll(
          '.price, .price *, .price-item, .product-card__price, .product-card__price *'
        ).forEach((text) => {
          text.style.color = '#111111';
          text.style.opacity = '1';
          text.style.background = 'transparent';
          text.style.textShadow = 'none';
          text.style.boxShadow = 'none';
        });

        item.querySelectorAll('.compare-at-price, .price__compare, s').forEach((text) => {
          text.style.color = 'rgba(17,17,17,0.45)';
          text.style.opacity = '1';
        });
      });
    };

    const applyFixes = () => {
      hideFloatingAdd();
      fixReadableText();
    };

    applyFixes();

    const observer = new MutationObserver(() => {
      applyFixes();
    });

    observer.observe(root, { childList: true, subtree: true });
  });

  } catch(e) { console.error(e); }
})();
})();
